import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const rateZoneLocationTypesAdapter = getAdapter({idFieldName: 'value'} );

const rateZoneLocationTypesSlice = createSlice({
    name: 'rateZoneLocationTypes',
    initialState: rateZoneLocationTypesAdapter.getInitialState(),
    reducers: {
        setRateZoneLocationTypes: (state, {payload: {rateZoneLocationTypes}}) => {
            rateZoneLocationTypesAdapter.setAll(state, rateZoneLocationTypes);
        }
    }
});

const selectors = rateZoneLocationTypesAdapter.getSelectors(({rateZoneLocationTypes}) => rateZoneLocationTypes);

export const getRateZoneLocationTypes = state =>  selectors.selectAll(state);

export const {setRateZoneLocationTypes} = rateZoneLocationTypesSlice.actions;
export default rateZoneLocationTypesSlice.reducer;